import {
  BILLING_BASE_Url,
  GET_BILL_DETAILS_Url,
  GET_BILL_HISTORY_Url,
} from "../const/URL";
import { IBillDetails } from "../interfaces/billDetails";
import { ApiResponse, BillDetails } from "../interfaces/billHistory";
import hasRequestError from "../util/hasRequestError";
import axiosInstance from "./axiosInstance";
import { getCustomerReferenceNumber } from "./localStorage";

export const getBillDetails = (accountNumber: string) => {
  return axiosInstance
    .get(
      `${GET_BILL_DETAILS_Url}?accountNumber=${accountNumber}&customerReferenceNumber=${getCustomerReferenceNumber()}`
    )
    .then((res) => {
      if (hasRequestError(res)) {
        throw new Error(
          !res.data.result ? res.data.displayMessage : res.data.result
        );
      }

      return res.data.result as IBillDetails;
    });
};
// export const getBillDetails = (accountNumber: string) => {
//   return axiosInstance
//     .get(
//       `${GET_BILL_DETAILS_Url}?accountNumber=${accountNumber}&customerReferenceNumber=${getCustomerReferenceNumber()}`
//     )
//     .then((res) => {
//       if (hasRequestError(res)) {
//         throw new Error(!res.data.result ? res.data.displayMessage : res.data.result);
//       }

//       return res.data.result as IBillDetails;
//     });
// };

export const getBillHistory = (accountNumber: string) => {
  return axiosInstance
    .get(
      `${GET_BILL_HISTORY_Url}?accountNumber=${accountNumber}&customerReferenceNumber=${getCustomerReferenceNumber()}&maxcount=5`
    )
    .then((res) => {
      if (hasRequestError(res)) {
        throw new Error(
          !res.data.result ? res.data.displayMessage : res.data.result
        );
      }

      return res.data.result as BillDetails[];
    });
};

export const downloadBill = (accountNumber: string) => {
  //if (process.env.REACT_APP_ENV === 'PRODUCTION') {
  return axiosInstance
    .get(
      `${BILLING_BASE_Url}/eBill-download?accountNumber=${accountNumber}&customerReferenceNumber=${getCustomerReferenceNumber()}`
    )
    .then((res) => {
      return res.data;
    });
  //} else {
  // return axiosInstance
  //     .get(
  //         `${BILLING_BASE_Url}/eBill?&customerReferenceNumber=CR004317027&invoiceNumber=0047262516-019X`
  //     )
  //     .then((res) => {
  //       return res.data;
  //     });
  //}
};

export const downloadBillByInvoiceNumber = (invoiceNumber: string) => {
  //if (process.env.REACT_APP_ENV === 'PRODUCTION') {
  return axiosInstance
    .get(
      `${BILLING_BASE_Url}/eBill?customerReferenceNumber=${getCustomerReferenceNumber()}&invoiceNumber=${invoiceNumber}&`
    )
    .then((res) => {
      return res.data;
    });
  //} else {
  // return axiosInstance
  //     .get(
  //         `${BILLING_BASE_Url}/eBill?&customerReferenceNumber=CR004317027&invoiceNumber=0047262516-019X`
  //     )
  //     .then((res) => {
  //       return res.data;
  //     });
  //}
};
